/// <reference path="users.items.js" />

export default function HelpAdminItemsService(gettext) {

	'ngInject';

	this.getModule = function () {
		var module = {
			"id": "admin",
			"name": gettext("Admin"),
			"description": gettext("The Admin section is where user, group and role administration is done."),
			"icon": "fas fa-question-circle",
			"priority": 8,
			"items": [{
				"orderid": 8.01,
				"itemid": "adminuserslist",
				"helpitemid": "admin.users",
				"name": gettext("View Users"),
				"templateUrl": "admin/view.users.html"
			},
			{
				"orderid": 8.02,
				"itemid": "adminuserdetails",
				"helpitemid": "admin.users",
				"name": gettext("User Details"),
				"templateUrl": "admin/view.users.details.html"
			},
			{
				"orderid": 8.03,
				"itemid": "admininviteuser",
				"helpitemid": "admin.invite",
				"name": gettext("Invite User"),
				"templateUrl": "admin/invite.users.html"
			},
			{
				"orderid": 8.04,
				"itemid": "adminmanageinvites",
				"helpitemid": "admin.invite",
				"name": gettext("Manage Invites"),
				"templateUrl": "admin/manage.invites.html"
			},
			{
				"orderid": 8.05,
				"itemid": "admininvitedetails",
				"helpitemid": "admin.invite",
				"name": gettext("Invite Details"),
				"templateUrl": "admin/invite.details.html"
			},
			{
				"orderid": 8.06,
				"itemid": "adminusersroleslist",
				"helpitemid": "admin.roles",
				"name": gettext("View Roles"),
				"templateUrl": "admin/view.roles.html"
			},
			{
				"orderid": 8.07,
				"itemid": "adminuserroledetails",
				"helpitemid": "admin.roles",
				"name": gettext("User Role Details"),
				"templateUrl": "admin/view.roles.details.html"
			},
			{
				"orderid": 8.08,
				"itemid": "admincreateuserrole",
				"helpitemid": "admin.roles.manage",
				"name": gettext("Create Role"),
				"templateUrl": "admin/create.role.html"
			},
			{
				"orderid": 8.09,
				"itemid": "adminsecuritygroups",
				"helpitemid": "admin.securitygroups",
				"name": gettext("View Security Groups"),
				"templateUrl": "admin/security.groups.html"
			},
			{
				"orderid": 8.10,
				"itemid": "adminsecuritygroupbase",
				"helpitemid": "admin.securitygroups",
				"name": gettext("Security Group Details"),
				"templateUrl": "admin/security.groups.details.html"
			},
			{
				"orderid": 8.11,
				"itemid": "admincreatesecuritygroup",
				"helpitemid": "admin.securitygroups.manage",
				"name": gettext("Create Security Group"),
				"templateUrl": "admin/create.security.group.html"
			},
			{
				"orderid": 8.12,
				"itemid": "assetstemplates",
				"helpitemid": "assets.templates",
				"name": gettext("Templates"),
				"templateUrl": "assets/assets.templates.html"
			},
			{
				"orderid": 8.13,
				"itemid": "attributes",
				"helpitemid": "attributes",
				"name": gettext("Attributes"),
				"templateUrl": "assets/assets.attrs.html"
			}
			]
		};

		return module;
	};
}